import React from 'react';
import { ServiceComingSoon } from '../../components/ServiceComingSoon';
import { Car } from 'lucide-react';
export function VehicleDecals() {
  return <ServiceComingSoon serviceName="Vehicle, Walls and Windows Decals" icon={<Car className="w-16 h-16 text-white" data-id="element-1963" />} data-id="element-1962" />;
}